import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class NAOUpdateStatusTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/NAOUpdateStatusTypes`);
    }
}